import * as React from "react";
import PropTypes from "prop-types";
import { Flex } from "grid-styled";
import styled, { css } from "styled-components";
import * as colors from "../settings/colors";

const gridGap = 14;

const Table = styled.div`
  display: block;
  font-size: 14px;
  width: 100%;
  border: 1px solid ${colors.TABLE_BORDER};
  border-bottom: 0;
  border-radius: ${({ noSideBorders }) => (noSideBorders ? 0 : "4px")};

  ${({ noSideBorders }) =>
    noSideBorders &&
    css`
      border-left: 0;
      border-right: 0;

      & ${TableCell}:first-child {
        padding-left: 0;
      }

      & ${TableCell}:last-child {
        padding-right: 0;
      }
    `};
`;

const TableCell = styled(Flex)`
  padding: 12px 0;
  align-items: center;
  box-sizing: border-box;

  &:first-child {
    padding-left: ${gridGap}px;
  }

  &:last-child {
    padding-right: ${gridGap}px;
  }
`;

const TableRow = ({ hover, header, columns, onHold, ...otherProps }) => (
  <div {...otherProps} />
);

const StyledTableRow = styled(TableRow)`
  display: grid;
  grid-column-gap: ${gridGap}px;
  grid-template-columns: ${props =>
    props.columns || "repeat(auto-fit, minmax(200px, 1fr))"};
  border-bottom: 1px solid ${colors.TABLE_BORDER};

  ${({ header }) =>
    header &&
    css`
      color: ${colors.TABLE_HEADER_TEXT};
      font-weight: 600;
      /* background: ${colors.TABLE_HEADER_BG}; */
    `};

  ${({ hover }) =>
    hover &&
    css`
      &:hover ${TableCell} {
        background: ${colors.TABLE_ROW_HOVER_BG};
      }
    `};

  ${({ onHold }) =>
    onHold &&
    css`
      color: ${colors.TEXT_SECONDARY};
      background: ${colors.TABLE_ROW_HOVER_BG};
    `};
`;

StyledTableRow.propTypes = {
  hover: PropTypes.bool,
  header: PropTypes.bool,
  columns: PropTypes.string
};

export { Table, TableCell, StyledTableRow as TableRow };
export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.js